import React from 'react';


export const generateLatitudeModal = ({ comments }) => (
  {
    title: 'Latitude (-90 to 90)',
    body: (
      <div>
        <div>
          Valid values:
          {' '}
          <b>-90 to 90</b>
        </div>
        <br />
        <p>
          Latitude: 0 to 90 (Northern Hemisphere) -90 to 0 (Southern Hemisphere)
        </p>
        <p>
          Events prior to 1900 were not instrumentally located, therefore, the location given is based on the latitude and longitude of the city where the maximum effects occurred.
        </p>
        {comments && (
        <p>
          {comments}
        </p>
        )}
      </div>
    ),
  }
);


export const LatitudeModal = generateLatitudeModal({});
